import {Injectable} from 'ng-metadata/core';

@Injectable()
export class StackMapService {
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/locations/stackMap/stackMap.service.ts